import CAApi from './_caApi';

class CAPaymentDetailTaxAPI extends CAApi {
  constructor() {
    super();
  }
  controllerName = 'CAPaymentDetailTaxs';
}

export default new CAPaymentDetailTaxAPI();
